<template>
  <div>
    <Card shadow>
      <Row :gutter="18">
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">代理:</span>
            <Select
              v-model="table.params.app_id"
              filterable
              placeholder="筛选代理"
              :max-tag-count="3"
              @on-change="getAppGenList"
              clearable
            >
              <Option
                v-for="(item, index) in getAppList()"
                :value="item.appid"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName }}
                <span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="3">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">商户:</span>
            <Select
              v-model="table.params.general_id"
              filterable
              placeholder="筛选 商户"
              :max-tag-count="3"
              @on-change="updateGeneral"
              clearable
              :disabled="table.params.query_type == 1"
            >
              <Option
                v-for="(item, index) in select.general_list"
                :value="item.general"
                :label="item.general_name"
                :key="index"
              >
                {{ item.general_name }}
                <span style="color: #bbb">({{ item.general }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 80px">子商户:</span>
            <Select
              v-model="table.params.pack_no"
              filterable
              placeholder="筛选 子商户"
              clearable
              :disabled="
                table.params.query_type == 1 || table.params.query_type == 2
              "
            >
              <Option
                v-for="(item, index) in getPackList()"
                :value="item.pack_no"
                :label="item.pack_name"
                :key="index"
              >
                {{ item.pack_name }}
                <span style="color: #bbb">({{ item.pack_no }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">玩家ID:</span>
            <Input
              v-model="table.params.user_id"
              placeholder="搜索 玩家ID"
              clearable
              :disabled="
                table.params.query_type == 1 ||
                  table.params.query_type == 2 ||
                  table.params.query_type == 3
              "
            ></Input>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">三方账号:</span>
            <Input
              v-model="table.params.external_account"
              placeholder="三方账号"
              clearable
              :disabled="
                table.params.query_type == 1 ||
                  table.params.query_type == 2 ||
                  table.params.query_type == 3
              "
            ></Input>
          </label>
        </Col>
      </Row>
      <Row :gutter="18" style="margin-top: 20px">
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">类型:</span>
            <Select
              v-model="table.params.query_type"
              placeholder="选择类型"
              clearable
              @on-change="queryTypeChange"
            >
              <Option
                v-for="item in select.Query_Type"
                :value="item.value"
                :key="item.value"
              >
                {{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">上级账号:</span>
            <Input
              v-model="table.params.superior_name"
              placeholder="上级账号"
              clearable
              :disabled="table.params.query_type == 1"
            ></Input>
          </label>
        </Col>

        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">上级ID:</span>
            <Input
              v-model="table.params.superior_id"
              placeholder="上级ID"
              clearable
              :disabled="table.params.query_type == 1"
            ></Input>
          </label>
        </Col>
        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">时间范围:</span>
            <DatePicker
              type="daterange"
              v-model="table.params.dataTime"
              :options="dateOptions"
              style="width: 100%"
            ></DatePicker>
          </label>
        </Col>
      </Row>
      <Row style="margin-top: 20px">
        <Col span="4" style="display: flex; justify-content: space-between">
          <Button type="primary" @click.native="searchData(true)">查询</Button>
          <div>
            <Button type="primary" @click.native="eleToExcel()"
              >导出excel</Button
            >
          </div>
        </Col>
      </Row>
    </Card>
    <Table
      border
      :columns="table.columns"
      :data="table.data"
      style="margin-top: 12px"
      :max-height="tableMaxHeight"
      ref="tableRef"
    ></Table>
    <Page
      style="margin-top:10px;"
      :total="page.total"
      show-total
      :current="page.currentPage"
      :page-size-opts="page.pageSizes"
      :page-size="page.pageSize"
      show-sizer
      @on-page-size-change="pageSizeChange"
      @on-change="pageChange"
    ></Page>
  </div>
</template>

<script>
import MulReportHeader from './components/mul_report_header.vue'
import { TransTopReq } from '@/api/admin/risk'
export default {
  name: 'TransferTotal',
  components: { MulReportHeader },
  data() {
    return {
      loading: false,
      TransTopReqTimer: null,
      timestamp: 0,
      tableMaxHeight: 0,
      all: {},
      select: {
        GameType_List: JSON.parse(localStorage.getItem('gameList')),
        Query_Type: [
          { name: '代理', value: 1 },
          { name: '商户', value: 2 },
          { name: '子商户', value: 3 },
          { name: '玩家', value: 4 }
        ],
        general_list: [],
        pack_list: []
      },
      table: {
        app_name: '',
        gp_name: '',
        params: {
          general_id: -1,
          platid: -1,
          app_id: -1,
          pack_no: -1,
          query_type: 1,
          external_account: '',
          dataTime: [
            new Date(
              this.getCurrentZeroDay().getTime() - 6 * 24 * 60 * 60 * 1000
            ),
            this.getCurrentZeroDay()
          ]
        },
        data: [],
        columns: [
          this.getRenderColumn('account_name', '账号名称', '显示账号的名称'),
          this.getRenderColumn('account_id', '账号ID', '显示账号的ID'),
          this.getRenderColumn(
            'external_account',
            '三方账号',
            '显示三方过来的玩家账号'
          ),
          this.getRenderColumn('account_type', '账号类型', '显示账号的类型'),
          this.getRenderColumn('superior_id', '上级ID', '显示上级账号的ID'),
          this.getRenderColumn('superior_name', '上级账号', '显示上级账号'),
          this.getRenderColumn(
            'transfer_in_total',
            '转入总金额',
            '显示记录的转入总金额'
          ),
          this.getRenderColumn(
            'transfer_out_total',
            '转出总金额',
            '显示记录的转出总金额'
          ),
          this.getRenderColumn('transfer_num', '划转次数', '显示划转的次数'),
          this.getRenderColumn(
            'transfer_success_num',
            '划转成功次数',
            '显示划转成功的次数'
          )
        ]
      },
      page: {
        total: 0,
        totalSum: 0,
        pageSize: 15,
        pageSizes: [15, 30, 45, 60],
        currentPage: 1
      }
    }
  },
  methods: {
    getRenderColumn(key, title, tip, width = 'auto') {
      return {
        key,
        width,
        align: 'center',
        resizable: true,
        renderHeader: h => this.renderHeader(h, title, tip),
        render: (h, params) => this.renderCol(h, params)
      }
    },
    // 重置数据
    resetData() {
      this.table.params = {
        general_id: -1,
        platid: -1,
        app_id: -1,
        pack_no: -1,
        query_type: 1,
        external_account: '',
        dataTime: [
          new Date(
            this.getCurrentZeroDay().getTime() - 6 * 24 * 60 * 60 * 1000
          ),
          this.getCurrentZeroDay()
        ]
      }
      this.table.params.platid = this.getinitPlatId()
      this.table.params.app_id = this.app_list.find(
        el => el.platform == this.table.params.platid
      )['appid']
    },
    //查询数据
    searchData(reset) {
      if (reset) {
        this.page.currentPage = 1
      }
      let stime = this.getSecond(this.table.params.dataTime[0])
      let etime = this.getSecond(this.table.params.dataTime[1], false)
      this.timestamp = new Date().getTime()
      let params = this.getTransTopParams('GetNewPlatfromData', {
        app_id: this.table.params.app_id,
        stime,
        etime,
        page: this.page.currentPage,
        limit: this.page.pageSize,
        query_type: this.table.params.query_type
          ? Number(this.table.params.query_type)
          : 1,
        general: this.table.params.general_id
          ? this.table.params.general_id
          : -1,
        pack_no: this.table.params.pack_no
          ? Number(this.table.params.pack_no)
          : -1,
        user_id: Number(this.table.params.user_id),
        superior_id: this.table.params.superior_id
          ? Number(this.table.params.superior_id)
          : -1,
        external_account: this.table.params.external_account,
        superior_name: this.table.params.superior_name
      })
      this.table.data = []
      let params1 = this.copyData(params)
      params1.param._func = 'GetTransferRecordSum'

      if (!this.table.params.app_id || this.table.params.app_id == -1) {
        const reqList = []
        const appList = this.getAppList()

        appList.forEach(item => {
          params1.param._param.app_id = item.appid
          reqList.push(TransTopReq(params1))
        })

        Promise.all(reqList).then(values => {
          let lists = []
          values.forEach(item => {
            if (item._param.list) {
              lists = lists.concat(item._param.list)
            }
          })
          this.table.data = lists
        })
      } else {
        params1.param._param.app_id = this.table.params.app_id
        TransTopReq(params1).then(res1 => {
          this.table.data = res1._param.list
          this.page.total = res1._param.total
        })
      }
    },
    renderCol(h, params) {
      let key = params.column.key
      let row = params.row

      if (key == 'account_type') {
        const data = this.select.Query_Type.find(
          item => item.value == row.account_type
        )
        return h('span', data.name)
      }
      if (key == 'external_account' || key == 'superior_name') {
        return this.renderNilData(h, params)
      }
      if (key.indexOf('_total') != -1) {
        return this.renderMoney(h, params)
      }
      return h('span', row[key])
    },
    getTableLength() {
      return Math.max(this.table.data.length - 1, 1)
    },
    getAppList() {
      return this.app_list.filter(el => this.table.params.platid == el.platform)
    },
    getAppGenList() {
      if (!this.table.params.app_id) return
      let params = this.getTransTopParams('GetAppGeneralList', {
        app_id: this.table.params.app_id,
        platid: this.table.params.platid,
        stime: this.getSecond(this.table.params.dataTime[0]),
        etime: this.getSecond(this.table.params.dataTime[1], false),
        page: 1,
        limit: 100,
        sort: 0,
        general: -1,
        pack_no: -1
      })
      this.select.general_list = []
      this.select.pack_list = []
      this.table.params.general_id = -1
      this.table.params.pack_no = -1
      TransTopReq(params).then(res => {
        this.select.general_list = res._param.general_list
        this.table.params.general_id = ''
        let params1 = this.copyData(params)
        params1.param._func = 'GetPackList'
        TransTopReq(params1).then(res => {
          this.select.pack_list = res._param.pack_list || []
        })
      })
    },
    updateGeneral() {
      this.table.params.pack_no = -1
    },
    getPackList() {
      return this.select.pack_list.filter(
        el => el.general == this.table.params.general_id
      )
    },
    //透传接口请求参数 请求方法 请求参数
    getTransTopParams(func, param) {
      return {
        mod: 'root',
        platid: this.table.params.platid,
        app_id: param.app_id,
        app_name: param.app_name,
        timestamp: param.timestamp,
        param: {
          _mod: 'manager',
          _func: func,
          _param: {
            ...param
          }
        }
      }
    },
    updatePlat() {
      this.table.params.app_id = this.getAppList()[0]['appid']
      this.getAppGenList()
    },
    initFunc() {
      this.table.params.platid = this.getinitPlatId()
      this.table.params.app_id = this.app_list.find(
        el => el.platform == this.table.params.platid
      )['appid']
      this.getAppGenList()
    },
    pageChange(page) {
      this.page.currentPage = page
      this.searchData()
    },
    pageSizeChange(size) {
      this.page.pageSize = size
      this.searchData()
    },
    queryTypeChange(value) {
      if (value == 1) {
        this.resetData()
        return
      }
      if (value == 2) {
        this.table.params.pack_no = -1
        this.table.params.user_id = ''
        this.table.params.external_account = ''
        return
      }
      if (value == 3) {
        this.table.params.user_id = ''
        this.table.params.external_account = ''
        return
      }
    }
  },
  activated() {
    this.initFunc()
    this.searchData()
  },
  mounted() {
    this.tableMaxHeight = window.document.body.clientHeight - 380
  }
}
</script>

<style scoped lang="less"></style>
